import ExplicitContainer from 'components/ExplicitLyrics/primitives/ExplicitContainer';
import ListItem from 'components/Article/primitives/ListItem';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';
import Text from 'components/Article/primitives/Text';

const SearchContent = styled('div')(({ theme }) => {
  return {
    display: 'block',
    height: '100%',
    overflow: 'auto',
    padding: `0 calc(48% - 25rem)`,
    textAlign: 'left',
    width: '100%',

    [Text.toString()]: {
      width: `calc(100% - 7rem)`,
    },

    [ExplicitContainer.toString()]: {
      marginRight: '1rem',
    },

    'section:first-of-type': {
      [ListItem.toString()]: {
        '&:first-of-type': {
          background: theme.colors.gray['200'],
        },
      },
    },

    [mediaQueryBuilder(theme.mediaQueries.max.width['640'])]: {
      margin: '5rem 0 7rem',
    },
  };
});

export default SearchContent;
